import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { OptionsService } from '../../options/services/options.service'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { IOptionsResponse } from '../../../common/common.types'
import { setStrokeCvaSymptomsResolvedOptions } from '../store/options.actions'

export function* getStrokeCvaSymptomsResolvedOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)

  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getStrokeCvaSymptomsResolvedOptions])
    const { entity } = response
    yield put(setStrokeCvaSymptomsResolvedOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getStrokeCvaSymptomsResolvedOptions() error: ${e}`))
  }
}

export function* getStrokeCvaSymptomsResolvedOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getStrokeCvaSymptomsResolvedOptions)
}
